import React from 'react';
import '../../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import YearController from "../../../../../services/data-declaration/year-controller";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import UserController from "../../../../../services/system/user/user-controller";
import {checkPermission} from "../../../../../utils/common";
import AutoSearchPeople from "../../../../../components/auto-search-people";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {getSchoolYear} from "../../../../../utils/authority";
import OfficerController from "../../../../../services/system/staff/officer-controller";

class modalEditSchoolYear extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listPeopleInSchool: [],
            monthInSemester1: 4,
            monthInSemester2: 4,
            principalId: "",
            principalName: "",
            principalUsername: "",

            endSemesterOne: '',
            endSemesterTwo: '',
            startSemesterOne: '',
            startSemesterTwo: '',
            year: '',
            startYear: '',
            id: -1,
            kethua: false
        };
    }
    componentDidMount() {
        this.getListPeopleInSchool();
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState({showLoading: true},
                () => {
                    this.getListOfficer(nextProps.id)
                    this.detailYear(nextProps.id)
                }
            )
        }
    }
    getListPeopleInSchool() {
        let payload = {
            "fullName": "",
            "gender": "",
            "group": "",
            "status": "",
            "username": "",
            "pageNumber": 0,
            "pageSize": 1000,
            "sort": "created_at desc"
        }
        UserController.searchUser(payload, res => {
            if (res.success) {
                if (res.data.content.length > 0){
                    this.setState({
                        listPeopleInSchool:  res.data.content
                    })
                }
            }
        });
    }
    getListOfficer(yearId){
        let payload = {
            yearId: yearId,
            pageNumber: 0,
            pageSize: 10000,
            birthday: '',
            code: '',
            contract: '',
            degree: '',
            departmentId: -1,
            fullName: '',
            gender: '',
            job: '',
            jobState: '',
            "sort": "created_at desc"
        };
        OfficerController.search(payload, res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listPeopleInSchool: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    }
    detailYear(yearId) {
        YearController.detail(yearId, res => {
            if (res.success) {
                let data = res.data;
                this.setState(
                    {
                        principalUsername: data.principalRes == null?"": data.principalRes.username,
                        principalId: data.principalRes == null? "": data.principalRes.id,
                        principalName: data.principalRes == null?"":data.principalRes.fullName,

                        "monthInSemester1": data.monthInSemester1,
                        "monthInSemester2": data.monthInSemester1,
                        "endSemesterOne": data.endSemesterOne,
                        "endSemesterTwo": data.endSemesterTwo,
                        "kethua": data.kethua,
                        "yearId": data.id,
                        "startSemesterOne": data.startSemesterOne,
                        "startSemesterTwo": data.startSemesterTwo,
                        "year": parseInt(data.year)
                    }
                );
            } else {
                toast.error(res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        });
    }
    editYear = () => {
        let payload = {
            id: this.state.yearId,
            kethua: this.state.kethua,
            year: this.state.year.toString(),
            endSemesterOne: this.state.endSemesterOne,
            endSemesterTwo: this.state.endSemesterTwo,
            startSemesterOne: this.state.startSemesterOne,
            startSemesterTwo: this.state.startSemesterTwo,
            principalUsername: this.state.principalUsername,
            monthInSemester1: parseInt(this.state.monthInSemester1),
            monthInSemester2: parseInt(this.state.monthInSemester1),
        }
        YearController.edit(payload, res => {
            if (res.success) {
                toast.success("Sửa năm học thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.warning(res.message[0] =="FORBIDDEN"? "Bạn không có quyền thực hiện chức năng này!" : res.message[0], {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 2000
                });
            }
        })
    }


    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered full-width-dialog">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Sửa thời gian năm học</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-4 row">
                                    <label className="col-12 label-item pl-0"><b>Dữ liệu sẽ được kế thừa từ năm học cũ nếu chọn "Kế thừa"</b></label>
                                    <label className="col-12 label-item pl-0">- Danh sách lớp học</label>
                                    <label className="col-12 label-item pl-0">- Danh sách môn học cho trường</label>
                                    <label className="col-12 label-item pl-0">- Danh sách môn học cho lớp</label>
                                </div>

                                <div className="col-md-5 col-xs-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Năm học(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={4}
                                        type="number"
                                        className="form-control shadow-none"
                                        value={this.state.year}
                                        onChange={(event) => {
                                            this.setState({
                                                year: event.target.value
                                            })
                                        }}
                                    />
                                    {/*<input*/}
                                    {/*    style={{marginRight: 30,}}*/}
                                    {/*    maxLength={4}*/}
                                    {/*    type="number"*/}
                                    {/*    className="form-control shadow-none"*/}
                                    {/*    value={this.state.endYear}*/}
                                    {/*    onChange={(event) => {*/}
                                    {/*        this.setState({*/}
                                    {/*            endYear: event.target.value*/}
                                    {/*        })*/}
                                    {/*    }}*/}
                                    {/*/>*/}
                                </div>
                                <div className="col-md-5 col-xs-12 d-flex mb-2">
                                    <label className="col-5 label-item pl-0">Hiệu trường</label>
                                    <Autocomplete
                                        size="small"
                                        options={this.state.listPeopleInSchool}
                                        getOptionLabel={option => option.fullName?option.fullName:"No Name"}
                                        style={{width: '100%'}}
                                        inputValue={this.state.principalName}
                                        renderInput={params => {
                                            return <TextField
                                                placeholder='Nhập tên'
                                                {...params}
                                                InputLabelProps={{
                                                    shrink: true,
                                                    style: {
                                                        fontSize: 17,
                                                        backgroundColor: "#FFF",
                                                        paddingRight: 10,
                                                        paddingLeft: 10,
                                                        color: '#2e495c',
                                                        fontWeight: 500,
                                                        fontFamily: 'Montserrat'
                                                    }
                                                }}
                                                label=""
                                                variant="outlined"
                                                fullWidth
                                            />
                                        }}
                                        onInputChange={(event, val) => {
                                            if (event !== null){
                                                this.setState({
                                                    principalName: val
                                                })
                                                if (val === ""){
                                                    this.state.principalId = -1;
                                                }
                                            }
                                        }}
                                        onChange={(e, val) => {
                                            if (val?.id != undefined){
                                                this.setState({
                                                    principalId: val?.id,
                                                    principalUsername: val?.username,
                                                    principalName: val?.fullName,
                                                })
                                            }else {
                                                this.setState({
                                                    principalId: -1,
                                                    principalUsername: "",
                                                    principalName: "",
                                                })
                                            }
                                        }}

                                    />
                                </div>
                                <div className="col-md-2 col-xs-12 d-flex mb-2">
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.kethua;
                                                this.setState({kethua: !value});
                                            }}
                                            checked={this.state.kethua}
                                        />
                                        {' '}
                                        Kế thừa
                                    </label>
                                </div>
                                <div className="col-12 d-flex mb-4">
                                    <label className="col-12 label-item pl-0"><b>Thông tin chi tiết</b></label>
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Số tháng /1 học kỳ(<span  style={{color: "red",}}>*</span>)</label>
                                    <input
                                        maxLength={12}
                                        type="number"
                                        className="form-control shadow-none"
                                        value={this.state.monthInSemester1}
                                        onChange={(event) => {
                                            this.setState({
                                                monthInSemester1: event.target.value
                                            })
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2"></div>
                                {/*<div className="col-md-6 col-xs-12 d-flex mb-2">*/}
                                {/*    <label className="col-5 label-item pl-0">Số tháng học kỳ 2(<span  style={{color: "red",}}>*</span>)</label>*/}
                                {/*    <input*/}
                                {/*        maxLength={12}*/}
                                {/*        type="number"*/}
                                {/*        className="form-control shadow-none"*/}
                                {/*        value={this.state.monthInSemester2}*/}
                                {/*        onChange={(event) => {*/}
                                {/*            this.setState({*/}
                                {/*                monthInSemester2: event.target.value*/}
                                {/*            })*/}
                                {/*        }}*/}
                                {/*    />*/}
                                {/*</div>*/}
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày bắt đầu học kỳ I<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.startSemesterOne === '' ? null : new Date(this.state.startSemesterOne)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        startSemesterOne: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>

                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày kết thúc học kỳ I<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.endSemesterOne === '' ? null : new Date(this.state.endSemesterOne)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        endSemesterOne: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày bắt đầu học kỳ II<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.endSemesterTwo === '' ? null : new Date(this.state.endSemesterTwo)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        endSemesterTwo: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-md-6 col-xs-12 d-flex mb-2">
                                    <label className="col-md-6 col-5 label-item pl-0">Ngày kết thúc học kỳ II<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.startSemesterTwo === '' ? null : new Date(this.state.startSemesterTwo)}
                                        minDate={new Date()}
                                        placeholderText="Ngày-Tháng-Năm"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        startSemesterTwo: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                {checkPermission("YEAR_EDIT") &&
                                    <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.editYear()}
                                    >
                                        <span className='justify-content-center'>
                                            Đồng ý
                                        </span>
                                    </button>
                                }
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export  default  modalEditSchoolYear
